module.exports = __webpack_public_path__ + "37b3395087969fad4434abf1c12ad2aa.pdf";